// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/wallet.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/wallet'

import { Icon, type IconComponentProps } from '../icon'

export const WalletIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
